import React, { useEffect, useState } from "react";
import { Shield, ShieldOff } from "lucide-react";
import { API_BASE_URL } from "src/config/apiBase";
import { decryptToken } from "../utils/getToken";
import { getLeadCompliance } from "../../utils/crmLeadMeta";
import { toast } from "react-toastify";

const CrmCompliancePanel = ({ leadId, lead, onUpdated }) => {
  const compliance = getLeadCompliance(lead);
  const [dnd, setDnd] = useState(compliance.dnd);
  const [consent, setConsent] = useState(compliance.consent);
  const [saving, setSaving] = useState(false);
  const url = API_BASE_URL;
  const token = decryptToken("accessToken") || "";

  useEffect(() => {
    const c = getLeadCompliance(lead);
    setDnd(c.dnd);
    setConsent(c.consent);
  }, [lead]);

  const save = async (patch) => {
    if (!leadId) return;
    setSaving(true);
    try {
      const res = await fetch(`${url}/leads/compliance/${leadId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(patch),
      });
      if (!res.ok) throw new Error("Save failed");
      const data = await res.json();
      setDnd(data.compliance?.dnd);
      setConsent(data.compliance?.consent !== false);
      onUpdated?.(data.compliance);
      toast.success("Compliance updated");
    } catch {
      toast.error("Could not update compliance");
    } finally {
      setSaving(false);
    }
  };

  if (!leadId) return null;

  return (
    <div className={`crm-compliance${dnd ? " crm-compliance--dnd" : ""}`}>
      <div className="crm-compliance__head">
        {dnd ? <ShieldOff size={16} /> : <Shield size={16} />}
        <strong>Compliance</strong>
        {dnd && <span className="crm-compliance__badge">DND</span>}
      </div>
      <label className="crm-automation__row">
        <input
          type="checkbox"
          checked={consent}
          disabled={saving}
          onChange={(e) => save({ consent: e.target.checked })}
        />
        <span>Marketing consent recorded</span>
      </label>
      <label className="crm-automation__row">
        <input
          type="checkbox"
          checked={dnd}
          disabled={saving}
          onChange={(e) => save({ dnd: e.target.checked })}
        />
        <span>Do Not Disturb — block outbound contact</span>
      </label>
    </div>
  );
};

export default CrmCompliancePanel;
